import { SharedState } from '@trello/shared-state';

/**
 * Signals that a success flag should be shown after planner auth completes
 * and data is refetched. Uses SharedState so the signal survives component
 * unmounts (e.g., the connect-account popover closing during auth).
 */
export const pendingAuthSuccessFlagState = new SharedState<boolean>(false);
